export const DISABLE_HOME_TOUR = 'DISABLE_HOME_TOUR';
export const DISABLE_USER_MENU_TOUR = 'DISABLE_USERMENU_TOUR';
